import Layout from "global/component/Genericos/Layout/Layout";
import { GlobalContext } from "global/context/Provider";
import camelize from "global/utils/camelize";
import { useContext } from "react";
import LogoDim from "_+_Portal/assets/images/generico/LogoDim";
import MiTurnoIcon from "_+_Portal/assets/images/generico/MiTurnoIcon";
import { PortalContext } from "_+_Portal/context/Provider";
import BtnLink from "_+_Portal/_-_Autocheckin/components/genericos/BtnLink/BtnLink";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";

import {
  BtnContainerSelectorCircuito,
  ContianerSelectorCircuito,
  HeaderSelectorCircuitoBar,
} from "./localStyle";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { containerVariants, itemVariants } from "global/utils/btnTransition";
import { motion } from "framer-motion";
import { OtrosTramites } from "_+_Portal/assets/images/generico/OtrosTramites";

const CircuitoSinTurno = () => {
  //#region --------- context ---------------
  const { pasoDispatch } = useContext(AutocheckContext);
  const { authState } = useContext(GlobalContext);
  const { selectDropDownState } = useContext(PortalContext);
  //#endregion  ----- context ---------------
  //#region  ----------- constants ---------------

  const pacienteNombre = selectDropDownState.selectDropDown.selectGlobal
    .pacienteElegido?.paciente?.nombre
    ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido?.paciente
        ?.nombre
    : authState.auth.data.paciente.nombre;

  let config = localStorage.getItem("config");
  let portal = JSON.parse(config).portal;
  //#endregion --------- constants ---------------

  //#region  ----------- funciones ---------------

  const volver = () => {
    setPaso("Home")(pasoDispatch);
  };

  const handleBtn = (orden) => {
    if (orden) {
      setPaso("OrdenesDigitales")(pasoDispatch);
    } else {
      setPaso("DemandaEspontanea")(pasoDispatch);
    }
  };

  //#endregion --------- funciones ---------------
  //#region  ----------- useEffect ---------------
  //#endregion  -------- useEffect ---------------

  return (
    <>
      <Layout origen={"NULL"} positionSidebar={21}>
        <ContianerSelectorCircuito
          initial="hidden"
          animate="show"
          variants={containerVariants}
        >
          <HeaderSelectorCircuitoBar>
            <div className="arrow" onClick={volver}>
              {"<"}
            </div>
            <span className="title">
              ¡Hola{" "}
              <span className="title-negrita">{camelize(pacienteNombre)}</span>!{" "}
            </span>
            <span className="title-pregunta">
              ¿En que podemos ayudarte{" "}
              <span className="title-negrita">hoy</span>?
            </span>
          </HeaderSelectorCircuitoBar>
          <BtnContainerSelectorCircuito>
            <motion.div variants={itemVariants}>
              <BtnLink
                Icon={<MiTurnoIcon color={"var(--color-primary)"} />}
                type={"NORMAL"}
                title={"ATENCIÓN SIN TURNO PREVIO"}
                onclick={() => handleBtn(false)}
              />
            </motion.div>
            <motion.div variants={itemVariants}>
              <BtnLink
                Icon={<OtrosTramites color={"var(--color-primary)"} />}
                type={"NORMAL"}
                title={"ÓRDENES PENDIENTES"}
                onclick={() => handleBtn(true)}
              />
            </motion.div>
          </BtnContainerSelectorCircuito>
          {portal && portal === "dim" ? (
            <div className="logo-dim">
              <LogoDim height={"550"} />
            </div>
          ) : (
            ""
          )}
        </ContianerSelectorCircuito>
      </Layout>
    </>
  );
};

export default CircuitoSinTurno;
